import { Menu } from "@mui/material";
import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import DropDownMenu from "./DropDownMenu";
import {
  PrimaryButton,
  Reject,
  Accept,
  AcceptUpload,
  PrimaryLoadingButton,
} from "../../css components/Button";
import pages from "../../../constants/pages";
import { useAxios } from "../../../hooks";
import { alert } from "../../../redux/slices/alertSlice";
import LaunchCampaignConfirm from "../../connection components/connection list components/dialog components/LaunchCampaignConfirm";
import Dialog from "../../../components/Dialog";
import ConfirmPopUp from "./campaign form components/Dialog";

export default function CampaignButtons({
  editState,
  liveUsers,
  audienceSize,
  formikProps,
  component,
  brandIdentity,
  setTakeUpOffer,
  setDialogUploadCSV,
  isDisabled,
  setBroadcastReportDialog,
}) {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [confirm, setConfirm] = useState({
    state: false,
  });
  const [dialog, setDialog] = useState({
    state: false,
  });
  const [loading, setLoading] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [sendApproval, setSendApproval] = useState(false);
  const [confirmPopUp, setConfirmPopUp] = useState({ state: false });

  const [launchCampaign, setLaunchCampaign] = useState(true);
  const [lockCampaignLoading, setLockCampaignLoading] = useState(false);

  const { activeBrand, userID } = useSelector((state) => state.memberDetails);

  const handleCampaignLive = () => {
    setLoading(true);
    axios({
      url: "/campaign/makeCampaignLive",
      method: "POST",
      disableRedirect: true,
      data: {
        campaign_id: parseInt(formikProps.values.campaignID),
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          IsManualCampaignLive: response.data.isManualCampaignLive,
          status: response.data?.status,
          campaignStatus: response.data?.campaignStatus,
          newCampaignStatus: response.data?.campaign_status || "LIVE_REQUESTED",
        }));
        dispatch(
          alert({ type: "success", message: response.message.displayMessage })
        );
      }
      setLoading(false);
    });
  };

  return (
    <Fragment>
      {component === "" &&
        formikProps.values.permissionSettings?.launch_campaign &&
        Boolean(formikProps.values?.adminCampaignStatus) &&
        formikProps.values?.campaignLaunched &&
        !formikProps.values.campaignInitiated &&
        launchCampaign && (
          <Accept
            variant="contained"
            onClick={() => setConfirm({ state: true })}
            disabled={lockCampaignLoading || !isDisabled}
          >
            {" "}
            Launch Campaign
          </Accept>
        )}

      {formikProps.values.campaignID &&
        !editState &&
        formikProps.values.permissionSettings.lock_campaign &&
        formikProps.values?.status === "CREATED" && (
          <PrimaryLoadingButton
            loading={lockCampaignLoading}
            onClick={() => {
              setDialog({
                state: true,
              });
            }}
            variant="contained"
          >
            Lock my Campaign
          </PrimaryLoadingButton>
        )}

      {formikProps.values.campaignID &&
        !editState &&
        formikProps.values.permissionSettings.sent_for_approval &&
        formikProps.values?.status === "CREATED" &&
        formikProps.values.adminApprovalStatus === "NOT_SENT" && (
          <PrimaryLoadingButton
            variant="contained"
            loading={sendApproval}
            sx={{ marginLeft: "5px" }}
            onClick={() => {
              setSendApproval(true);
              axios({
                url: "/send/campaign/admin/approval",
                method: "POST",
                data: {
                  campaign_id: formikProps.values.campaignID,
                  brand_id: activeBrand.ID,
                  user_id: userID,
                },
              }).then((response) => {
                if (response.status) {
                  formikProps.setValues((prev) => ({
                    ...prev,
                    message: response.data.approval_msg,
                    adminApprovalStatus: response.data.approval_status,
                    newCampaignStatus: response.data.approval_status,
                  }));
                  dispatch(
                    alert({
                      type: "success",
                      message: response.data.approval_msg,
                    })
                  );
                  setSendApproval(false);
                }
              });
            }}
          >
            Send for Approval
          </PrimaryLoadingButton>
        )}

      {formikProps.values?.campaignID &&
        formikProps.values?.status === "ACTIVE" &&
        formikProps.values?.requestStatus === "ACCEPTED" &&
        formikProps.values.permissionSettings.display_stats && (
          <PrimaryButton
            onClick={() =>
              navigate(
                pages.analytics.route +
                  formikProps.values.campaignID +
                  "?campaignName=" +
                  formikProps.values?.campaign_name?.value
              )
            }
            variant="contained"
          >
            Analytics
          </PrimaryButton>
        )}

      {component === "" &&
        formikProps.values.campaignID &&
        formikProps.values?.newCampaignStatus === "ACCEPTED" && (
          <PrimaryButton
            style={{ marginLeft: "5px" }}
            onClick={() => {
              setConfirmPopUp({
                state: true,
                data: {
                  content: "Ready Campaign",
                  handleFunction: handleReadyCampaign,
                },
              });
            }}
            variant="contained"
          >
            Ready my Campaign
          </PrimaryButton>
        )}

      {component === "" &&
        formikProps.values.campaignID &&
        (formikProps.values?.status === "READY" ||
          formikProps.values?.newCampaignStatus === "READY") && (
          <PrimaryLoadingButton
            variant="contained"
            loading={loading}
            disabled={!isDisabled}
            onClick={handleCampaignLive}
          >
            Campaign Go Live
          </PrimaryLoadingButton>
        )}

      {brandIdentity &&
        component !== "accepted" &&
        formikProps.values.requestStatus === "REQUESTED" && (
          <Fragment>
            {!(
              audienceSize?.audience_params || audienceSize?.audience_size
            ) && (
              <Reject
                size="large"
                variant="contained"
                style={{ marginRight: "5px" }}
                onClick={() =>
                  setTakeUpOffer((prevVal) => ({
                    ...prevVal,
                    action: "REJECTED",
                    state: true,
                  }))
                }
              >
                Reject
              </Reject>
            )}

            <Accept
              size="large"
              variant="contained"
              disabled={
                parseInt(liveUsers?.liveUser) <= 0 || !liveUsers.liveUser
              }
              // style={{ marginRight: "5px" }}
              onClick={() =>
                setTakeUpOffer((prevVal) => ({
                  ...prevVal,
                  action: "ACCEPTED",
                  state: true,
                }))
              }
            >
              Accept
            </Accept>
          </Fragment>
        )}

      {component === "request" &&
        formikProps.values.csvUpload &&
        (formikProps.values.campaignStatus === "REQUESTED" ||
          formikProps.values.campaignStatus === "REJECTED") && (
          <AcceptUpload
            variant="contained"
            onClick={() => setDialogUploadCSV(true)}
            // sx={{ marginLeft: "5px" }}
          >
            UPLOAD ACCEPT
          </AcceptUpload>
        )}

      {formikProps.values.status === "ACTIVE" &&
        formikProps.values.requestStatus !== "MISSED" && (
          <Fragment>
            <PrimaryLoadingButton
              variant="outlined"
              size="large"
              loading={loading}
              sx={{
                marginLeft: "5px",
                whiteSpace: "nowrap",
              }}
              onClick={(event) => {
                if (component === "") {
                  setMenuAnchor(event.currentTarget);
                }

                if (component === "request") {
                  handleDownloadReport();
                }
              }}
            >
              Report
            </PrimaryLoadingButton>

            <Menu
              style={{ marginTop: "10px" }}
              open={!!menuAnchor}
              anchorEl={menuAnchor}
              onClose={() => setMenuAnchor(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <DropDownMenu
                formikProps={formikProps}
                setLoading={setLoading}
                setMenuAnchor={setMenuAnchor}
              />
            </Menu>
          </Fragment>
        )}

      <Dialog
        dialogState={dialog}
        setDialogState={setDialog}
        dialogContent={{
          title: "Lock Campaign",
          body: "Are you sure you want to lock campaign?",
          primaryButton: "Confirm",
        }}
        handleAgree={handleLockCampaign}
      />
      <LaunchCampaignConfirm
        formikProps={formikProps}
        confirm={confirm}
        setConfirm={setConfirm}
        campaignID={formikProps.values.campaignID}
        setLaunchCampaign={setLaunchCampaign}
      />
      <ConfirmPopUp
        dialogState={confirmPopUp}
        setDialogState={setConfirmPopUp}
      />
    </Fragment>
  );

  function handleReadyCampaign() {
    axios({
      url: "/user/readyCampaign",
      method: "POST",
      disableRedirect: true,
      data: { campaign_id: formikProps.values.campaignID },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          status: response?.data?.status,
          campaignStatus: response.data?.status,
          campaign_status: response.data?.campaign_status,
          newCampaignStatus: response.data?.status,
          audienceMessage: "Processing...",
        }));
        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
      }
    });
  }

  function handleLockCampaign() {
    setLockCampaignLoading(true);
    axios({
      url: "/user/lockCampaign",
      method: "POST",
      disableRedirect: true,
      data: {
        campaign_id: formikProps.values.campaignID,
        sender_brandId: formikProps.values.brandID,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          status: response?.data?.status,
          isPendingSizing: true,
          isSizingSetOnTime: true,
          campaignStatus: response.data?.status,
          newCampaignStatus: response.data?.status,
        }));

        setLockCampaignLoading(false);

        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
      } else {
        setLockCampaignLoading(false);
      }
    });
  }

  function handleDownloadReport() {
    setLoading(true);
    let url = "/brand/campaign/report/" + formikProps.values?.campaignID;
    if (component === "request") {
      url = "/contributer/campaign/report/" + formikProps.values?.campaignID;
    }

    axios({
      url: url,
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          window.location.href = response?.data?.reportUrl;
          dispatch(
            alert({
              type: "success",
              message: "Report was successfully downloaded.",
            })
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }
}
